/** Error codes shared by server and clients. Clients translate codes, never sentences. */
export const ERROR_STATUS = {
  VALIDATION: 400,
  UNAUTHENTICATED: 401,
  INVALID_TOKEN: 401,
  TOKEN_EXPIRED: 401,
  TOKEN_REUSED: 401,
  FORBIDDEN: 403,
  /** Receipt AI needs the user's consent first (docs/06-beleg-ki.md, Datenschutz). */
  AI_CONSENT_REQUIRED: 403,
  /** E-mail not confirmed yet: new logins confirm it before mails leave the account, invites and purchases. */
  EMAIL_NOT_VERIFIED: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  DUPLICATE: 409,
  LIMIT_REACHED: 402,
  /** The action needs units that are locked (more billable units than the plan covers, docs/BILLING.md §5). */
  UNITS_LOCKED: 402,
  /** The KI-Assistent needs Premium; the one-time trial is used up (docs/17 §Premium). */
  AGENT_PREMIUM_REQUIRED: 402,
  /** Finalise/send while the web payment failed and Stripe retries (past_due, docs/BILLING.md §5.4). */
  PAYMENT_HOLD: 409,
  LOCKED: 423,
  PRECONDITION_REQUIRED: 428,
  /** Creating a landlord account needs the accepted AGB and the acknowledged Datenschutzerklärung (current versions). */
  LEGAL_CONSENT_REQUIRED: 428,
  RATE_LIMITED: 429,
  KILLSWITCH: 503,
  NOT_CONFIGURED: 503,
  INTERNAL: 500,
} as const;
export type ErrorCode = keyof typeof ERROR_STATUS;

/** Auth codes on which clients end the session (B9). Everything else keeps the user logged in. */
export const SESSION_ENDING_CODES: ErrorCode[] = ['INVALID_TOKEN', 'TOKEN_EXPIRED', 'TOKEN_REUSED', 'UNAUTHENTICATED'];

export type ApiSuccess<T> = { success: true; data: T; meta?: { pagination?: { nextCursor: string | null; hasMore: boolean } } };
/** Params of a translatable server message (ISO dates are localized by the client). */
export type ErrorParams = Record<string, string | number>;
/**
 * Translatable server message: stable `key` (packages/i18n errors.json `server.<key>`) + `params`; `message` stays the
 * German text for older clients. Used for API errors and for per-row errors in `details` (imports).
 */
export type ServerMessage = { key: string; params?: ErrorParams; message: string };
export type ApiError = { success: false; error: { code: ErrorCode; message: string; key?: string; params?: ErrorParams; field?: string; details?: unknown } };
